import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import theme, { colors } from '../theme';
import { BackNav } from './Nav';
import Footer from './Footer';

export default function LegalPage({ title, fileUrl }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BackNav />
      <Box sx={{ pt: { xs: 10, md: 12 }, pb: 6, backgroundColor: colors.gray }}>
        <Container>
          <Typography variant="h3" sx={{ textAlign: 'center' }}>{title}</Typography>
        </Container>
      </Box>
      <Container sx={{ py: 4 }}>
        <Box
          sx={{
            height: '80vh',
            border: `1px solid ${colors.grayBorder}`,
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer fileUrl={fileUrl} />
          </Worker>
        </Box>
      </Container>
      <Footer />
    </ThemeProvider>
  );
}
